import {H5ObservationData, H5ObservationVariant} from 'src/lib/api/h5';
import {
  AllColumns,
  ApiObservationTimeSeries,
  FlowObservationColumns,
  Source,
  TimeSeriesData,
  TimeSeriesVariables,
} from 'src/lib/api/series';

export const H5_OBSERVATION_COLUMN_BY_VARIANT: Record<H5ObservationVariant, AllColumns> = {
  // Raw observation columns have no enum member because legacy gauges use arbitrary column names.
  raw: 'observed' as AllColumns,
  cleaned: FlowObservationColumns.observed_clean,
};

export function toObservationTimeSeries(
  data: H5ObservationData,
  {siteId, projectId}: {siteId: string; projectId: string}
): ApiObservationTimeSeries {
  const variables: TimeSeriesVariables = {};
  const values: TimeSeriesData = {};
  for (const variable of data.variables) {
    const column = H5_OBSERVATION_COLUMN_BY_VARIANT[variable.observationVariant];
    variables[column] = {unit: variable.unit};
    values[column] = data.values[variable.name] ?? [];
  }
  return {
    query: {siteId, projectId, source: Source.HFObservations, columns: Object.keys(values)},
    variables,
    data: values,
    timestamps: data.validTimes,
    dataTimeRange: [data.validTimes[0], data.validTimes[data.validTimes.length - 1]],
  };
}
